<template>
  <b-container fluid>
    <b-row>
      <b-col cols="12">
        <ul v-for="(node, index) in tree">
          <node
            :selectable-type="selectableType"
            :handle-click="handleClick"
            :key="index"
            :node="node"
            class="node"/>
        </ul>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'
import node from './node'

export default {
  components: {
    node
  },
  props: {
    selectableType: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    ...mapState('client', {
      tree: 'contentTree'
    })
  },
  methods: {
    handleClick (node) {
      this.$emit('selected', node)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/move-entity/index.vue